import {useEffect, useState} from 'react'
import { useAuth } from '../context/AuthContext';
import axios from 'axios'
import "./BusinessLessons.css"


const BusinessLessons = () => {
    const { business, businessToken} = useAuth()
    const [message, setMessage] = useState(null)
    const [itemMessage, setItemMessage] = useState({})
    const [allTime, setAllTime] = useState(true)
    const [today, setToday] = useState(true)
    const [templateData, setTemplateData] = useState([])
    const [formData, setFormData] = useState({
        name: '',
        business: business?._id || '',
        instructor: '',
        cost: "",
        days: {
          monday: { active: false, time: '' },
          tuesday: { active: false, time: '' },
          wednesday: { active: false, time: '' },
          thursday: { active: false, time: '' },
          friday: { active: false, time: '' },
          saturday: { active: false, time: '' },
          sunday: { active: false, time: '' },
        },
        capacity: "",
        duration: "",
        startDate: '',
        endDate: '',
        active: true,
        place: "",
      });

    const inputChange = (e) => {
        const {name, value} = e.target

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }))
    }

    const toogleDayActive = (day) => {
        setFormData((prev) => ({
            ...prev,
            days: {
                ...prev.days,
                [day]: {
                    ...prev.days?.[day],
                    active: !prev.days?.[day]?.active
                }
            }
        }));
    };

    const timeChange = (day, value) => {
        setFormData((prev) => ({
            ...prev,
            days: {
                ...prev.days,
                [day]: {
                    ...prev.days[day],
                    time: value
                }
            }
        }))
    }


    const formSubmit = async (e) => {
        e.preventDefault()
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/lessons/create`,
                formData,
                {
                  headers: {
                    Authorization: `Bearer ${businessToken}`
                  }
                }
              );
            setMessage(response.data.message)
        } catch (err) {
            setMessage(err.response?.data?.message)
        } finally {
            setTimeout(() => {
                setMessage(null)
            }, 2000)
            fetchNewData()
            setFormData({
                name: '',
                business: business?._id || '',
                instructor: '',
                cost: "",
                days: {
                  monday: { active: false, time: '' },
                  tuesday: { active: false, time: '' },
                  wednesday: { active: false, time: '' },
                  thursday: { active: false, time: '' },
                  friday: { active: false, time: '' },
                  saturday: { active: false, time: '' },
                  sunday: { active: false, time: '' },
                },
                capacity: "",
                duration: "",
                endDate: "untilTheEnd",
                startDate: new Date().toISOString().split('T')[0],
                active: true,
                place: "",
              });
        }
    }

      const handleDeleteTemplate = async (id) => {
        if ( businessToken) {
          try {
            const templateId = id
            const response = await axios.delete(`${process.env.REACT_APP_API_URL}/lessons/delete-template`, {
              params: {templateId},
              headers: {
                Authorization: `Bearer ${businessToken}`
              }
            })
            setItemMessage(prev => ({
              ...prev,
              [id]: response.data?.message || "Smazáno"
            }))
          } catch (err) {
            setItemMessage(prev => ({
              ...prev,
              [id]: err.response?.data?.message || "Chyba při odeslání"
            }))
          } finally {
            setTimeout(() => {
                setItemMessage({})
            }, 2000)
            setTimeout(() => {
            fetchNewData()
            }, 2500)
          }
          }
      }


    useEffect(() => {
        if (allTime) {
            setFormData((prev) => ({
                ...prev,
                endDate: "untilTheEnd",
            }))
        }
    }, [allTime])

    useEffect(() => {
        if (today) {
            const todayDate = new Date().toISOString().split('T')[0]

            setFormData((prev) => ({
                ...prev,
                startDate: todayDate,
            }))
        }
    }, [today])

    useEffect(() => {
        if (business && businessToken) {
            setFormData((prev) => ({
                ...prev,
                business: business._id,
            }))
        const fetchData = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/lessons/get-template`, {
                    params: {businessId: business._id}
                })
                setTemplateData(response.data)
                console.log(response.data)
            } catch (err) {
                console.log("Žádný info o lekcích")
            }
          }
          fetchData()
        }
    }, [business, businessToken])

    const fetchNewData = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/lessons/get-template`, {
                params: {businessId: business._id}
            })
            setTemplateData(response.data)
            console.log(response.data)
        } catch (err) {
            console.log("Žádný info o lekcích")
        }
      }



  return (
    <div>
        <div>

        <form onSubmit={formSubmit}>
        <div className='lessons-settings-container'>
        <div className="lesson-column">
        <div className='settings-container'>
            <h2 className='check-title'>Název lekce:</h2>
            <input 
                type='text'
                name="name"
                value={formData.name}
                onChange={inputChange}
                className="hotel-input"
                required
            /> 
        </div>
        <div className='settings-container'>
            <h2 className='check-title'>Instruktor:</h2>
            <input 
                type='text'
                name="instructor"
                value={formData.instructor}
                onChange={inputChange}
                className="hotel-input"
                required
            /> 
        </div>
        <div className='settings-container'>
            <h2 className='check-title'>Maximální obsazenost:</h2>
            <input 
                type='number'
                name="capacity"
                value={formData.capacity}
                onChange={inputChange}
                className="hotel-input"
                required
            /> 
        </div>
        <div className='settings-container'>
            <h2 className='check-title'>Cena na osobu:</h2>
            <input 
                type='number'
                name="cost"
                value={formData.cost}
                onChange={inputChange}
                className="hotel-input"
                placeholder='Kč'
                required
            /> 
        </div>
        <div className='settings-container'>
            <h2 className='check-title'>Místo:</h2>
            <input 
                type='text'
                name="place"
                value={formData.place}
                onChange={inputChange}
                className="hotel-input"
                
            /> 
        </div>
        <div className='settings-container'>
            <h2 className='check-title'>Délka lekce:</h2>
            <select
                className='basic-input reservation-select'
                name="duration"
                value={formData.duration}
                onChange={inputChange}
                required
            > 
                <option value="">Možnosti</option>
                <option value="15">15 minut</option>
                <option value="30">30 minut</option>
                <option value="45">45 minut</option>
                <option value="60">1 hodina</option>
                <option value="75">1 hodina 15 minut</option>
                <option value="90">1 hodina 30 minut</option>
                <option value="105">1 hodina 45 minut</option>
                <option value="120">2 hodiny</option>
                <option value="135">2 hodiny 15 minut</option>
                <option value="150">2 hodiny 30 minut</option>
                <option value="165">2 hodiny 45 minut</option>
                <option value="180">3 hodiny</option>
                <option value="195">3 hodiny 15 minut</option>
                <option value="210">3 hodiny 30 minut</option>
                <option value="225">3 hodiny 45 minut</option>
                <option value="240">4 hodiny</option>
                <option value="255">4 hodiny 15 minut</option>
                <option value="270">4 hodiny 30 minut</option>
                <option value="285">4 hodiny 45 minut</option>
                <option value="300">5 hodin</option>
            </select>
        </div>
        <div className='settings-container'>
            <h2 className='check-title'>Platnost od dnes:</h2>
            <input 
                type='checkbox'
                name="today"
                checked={today}
                onChange={() => setToday(!today)}
                className='hotel-input-checkbox'
            /> 
        </div>
        { !today && <div className='settings-container'>
            <h2 className='check-title'>Datum začátku:</h2>
            <input 
                type='date'
                name="startDate"
                value={formData.startDate}
                onChange={inputChange}
                className="hotel-input"
            /> 
        </div>}
        <div className='settings-container'>
            <h2 className='check-title'>Platnost na rok:</h2>
            <input 
                type='checkbox'
                name="allTime"
                checked={allTime}
                onChange={() => setAllTime(!allTime)}
                className='hotel-input-checkbox'
            /> 
        </div>
        { !allTime && <div className='settings-container'>
            <h2 className='check-title'>Datum ukončení:</h2>
            <input 
                type='date'
                name="endDate"
                value={formData.endDate}
                onChange={inputChange}
                className="hotel-input"
            /> 
        </div>}
    </div>
    <div className="lesson-column">
        <div className="settings-container">
    <h2 className='check-title'>Pondělí:</h2>
    <div className='checkbox-time' >
        {formData.days?.monday?.active && (
            <input
                type='time'
                value={formData.days?.monday?.time}
                onChange={(e) => timeChange("monday", e.target.value)}
                className="input-time"
            />
        )}
        <input
            type='checkbox'
            checked={formData.days?.monday?.active}
            onChange={() => toogleDayActive("monday")}
            className='hotel-input-checkbox'
        />
    </div>
</div>

<div className='settings-container'>
    <h2 className='check-title'>Úterý:</h2>
    <div className='checkbox-time' >
        {formData.days?.tuesday.active && (
            <input
                type='time'
                value={formData.days?.tuesday.time}
                onChange={(e) => timeChange("tuesday", e.target.value)}
                className="input-time"
            />
        )}
        <input
            type='checkbox'
            checked={formData.days?.tuesday.active}
            onChange={() => toogleDayActive("tuesday")}
            className='hotel-input-checkbox'
        />
    </div>
</div>

<div className='settings-container'>
    <h2 className='check-title'>Středa:</h2>
    <div className='checkbox-time' >
        {formData.days?.wednesday.active && (
            <input
                type='time'
                value={formData.days?.wednesday.time}
                onChange={(e) => timeChange("wednesday", e.target.value)}
                className="input-time"
            />
        )}
        <input
            type='checkbox'
            checked={formData.days?.wednesday.active}
            onChange={() => toogleDayActive("wednesday")}
            className='hotel-input-checkbox'
        />
    </div>
</div>

<div className='settings-container'>
    <h2 className='check-title'>Čtvrtek:</h2>
    <div className='checkbox-time' >
        {formData.days?.thursday.active && (
            <input
                type='time'
                value={formData.days?.thursday.time}
                onChange={(e) => timeChange("thursday", e.target.value)}
                className="input-time"
            />
        )}
        <input
            type='checkbox'
            checked={formData.days?.thursday.active}
            onChange={() => toogleDayActive("thursday")}
            className='hotel-input-checkbox'
        />
    </div>
</div>

<div className='settings-container'>
    <h2 className='check-title'>Pátek:</h2>
    <div className='checkbox-time' >
        {formData.days?.friday.active && (
            <input
                type='time'
                value={formData.days?.friday.time}
                onChange={(e) => timeChange("friday", e.target.value)}
                className="input-time"
            />
        )}
        <input
            type='checkbox'
            checked={formData.days?.friday.active}
            onChange={() => toogleDayActive("friday")}
            className='hotel-input-checkbox'
        />
    </div>
</div>

<div className='settings-container'>
    <h2 className='check-title'>Sobota:</h2>
    <div className='checkbox-time' >
        {formData.days?.saturday.active && (
            <input
                type='time'
                value={formData.days?.saturday.time}
                onChange={(e) => timeChange("saturday", e.target.value)}
                className="input-time"
            />
        )}
        <input
            type='checkbox'
            checked={formData.days?.saturday.active}
            onChange={() => toogleDayActive("saturday")}
            className='hotel-input-checkbox'
        />
    </div>
</div>

<div className='settings-container'>
    <h2 className='check-title'>Neděle:</h2>
    <div className='checkbox-time' >
        {formData.days?.sunday.active && (
            <input
                type='time'
                value={formData.days?.sunday.time}
                onChange={(e) => timeChange("sunday", e.target.value)}
                className="input-time"
            />
        )}
        <input
            type='checkbox'
            checked={formData.days?.sunday.active}
            onChange={() => toogleDayActive("sunday")}
            className='hotel-input-checkbox'
        />
    </div>
</div>
</div>
</div>
<div className='checkbox-time' >
            <button className='profile-button' type="submit">Vytvořit lekci</button>

</div>
        </form>
        {message && <p className='message'>{message}</p>}
        </div>
        <div className='lesson-template-list'>
            {templateData.map((item) => {
                return <div key={item._id} className="lesson-template">
                    <div className='lesson-title'>
                <h2>{item.name}</h2>
                </div>
                <div className='lesson-info'>
                <div className="all-service-description">
                  <h2 className='check-title'>Instruktor:</h2><p> {item.instructor}</p>
                </div>
                <div className="all-service-description">
                  <h2 className='check-title'>Od:</h2><p> {new Date(item.startDate).toLocaleDateString()}</p>
                </div>
                <div className="all-service-description">
                  <h2 className='check-title'>Do:</h2><p> {new Date(item.endDate).toLocaleDateString()}</p>
                </div>
                </div>
                <div className="lesson-days">
                  <h3>Dny konání</h3>
                    {Object.keys(item.days).map((day, index) => {
                        const dayConfig = item.days[day]
                        
                        const dayTranslations = {
                            monday: 'Pondělí',
                            tuesday: 'Úterý',
                            wednesday: 'Středa',
                            thursday: 'Čtvrtek',
                            friday: 'Pátek',
                            saturday: 'Sobota',
                            sunday: 'Neděle',
                        };
                        
                        return <div className='lesson-info' key={index}>
                            { dayConfig.active && <div className="all-service-description">
                                <h2 className='check-title'>{dayTranslations[day]}</h2><p>{dayConfig.time}</p>
                            </div>}
                        </div>
                    })

                    }
                </div>
                <div>
                    <button className="lesson-button" onClick={() => handleDeleteTemplate(item._id)}>Smazat</button>
                    {itemMessage[item._id] && <p className="message">{itemMessage[item._id]}</p>}
                </div>
              </div>
            })}
        </div>

    </div>
  )
}

export default BusinessLessons